document.addEventListener("DOMContentLoaded", function() {
    const stickyBox = document.querySelector('.sticky-box');
    const footer = document.getElementById('shopify-section-sections--23496804073821__footer');

    // Sprawdzenie, czy stickyBox istnieje
    if (!stickyBox) {
        console.log('StickyBox not found, script not needed on this page.');
        return; // Zakończ działanie skryptu, jeśli stickyBox nie istnieje
    }

    function checkFooterPosition() {
        const footerRect = footer.getBoundingClientRect();
        const stickyBoxHeight = stickyBox.offsetHeight;

        // Sprawdza, czy sticky box powinien być nad stopką
        if (footerRect.top < window.innerHeight) {
            stickyBox.style.bottom = `${window.innerHeight - footerRect.top}px`;
        } else {
            stickyBox.style.bottom = '0';
        }
    }

    window.addEventListener('scroll', checkFooterPosition);
    window.addEventListener('resize', checkFooterPosition);
    checkFooterPosition();
});
